import React, {Component} from 'react'
import '../../styles/Admin.css'
import {Tab, Tabs} from "react-bootstrap-tabs";
import ZarzadzaniePlikami from "./plikiComponents/ZarzadzaniePlikami";
import AdminPanel from "../AdminPanel";
// import '../../styles/Tabs.css'

export default class AdminEventy extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedItem: '',
            title: '',
            selectedIndex: 0
        }
    }

    render() {
        return <AdminPanel>
            <div className="componentContainer">
                <h5 style={{paddingLeft: 10}}>Pliki</h5>
                <hr/>
                <Tabs selected={this.state.selectedIndex} onSelect={(index, label) => {
                    this.setState({selectedIndex: index});
                }}>
                    <Tab label={'Zarządzanie plikami'}>
                        <ZarzadzaniePlikami goNowyWpis={() => this.setState({selectedIndex: 1})}
                                            goEdycja={() => this.setState({selectedIndex: 2})}
                                            setItem={(item) => this.setState({selectedItem: item, title: item.tytul})}/>
                    </Tab>
                </Tabs>
            </div>
        </AdminPanel>
    }

}



// WEBPACK FOOTER //
// ./src/components/admin/adminComponents/AdminPliki.js